import { Injectable, signal } from "@angular/core";
import { AlertV2Component } from "../alert-v2/alert-v2.component";
export interface AlertButton {
  title: string;
  btn_class: string;
  onClick: any;
  icon?: string;
  focus?: boolean;
}
export interface ConfirmationAlert {
  title: string;
  body: string;
  buttons?: AlertButton[];
  confirmLabel: string;
  onConfirm?: any;
  onClose?: any;
  confirmDanger?: boolean;
  confirmFocus?: boolean;
  cancelLabel?: string;
  hideCancel?: boolean;
  disableClose?: boolean;
  onSecondaryAction?: any;
  secondaryLabel?: string;
}
@Injectable({ providedIn: "root" })
export class AlertService {
  showAlert: Boolean = false;
  size: string = "modal-md";
  showFooter: boolean = false;
  title: string = "";
  loading = signal(false);
  body: string = "";
  title_icon: string | null = null;
  title_color: string = "";
  syncing = signal(false);
  iconCheck = 'check_circle';
  iconTimesCircle = 'cancel';
  buttons: AlertButton[] = [];
  onCloseAction: any = null;
  setAlert(
    title: string,
    body: string,
    size?: string,
    buttons?: AlertButton[],
  ) {
    this.title = title;
    this.body = body;
    if (size) {
      this.size = size;
    }
    if (buttons) {
      this.showFooter = true;
      this.buttons = buttons;
    } else {
      this.showFooter = false;
    }
    this.showAlert = true;
  }
  setConfirmationAlert(
    title: string,
    body: string,
    confirmLabel: string,
    onConfirm?: any,
    confirmDanger?: boolean,
    confirmFocus?: boolean,
  ) {
    this.size = "modal-md";
    //this.title_icon = 'check_circle';
    this.title = title;
    //this.title_color = "text-success";
    this.body = body;
    this.showFooter = true;
    this.buttons = [
      {
        title: "Cancelar",
        btn_class: "btn-default",
        onClick: () => {
          this.closeAlert();
        },
        focus: false,
      },
      {
        title: confirmLabel,
        btn_class: confirmDanger ? "btn-danger" : "btn-primary",
        onClick: () => {
          if (onConfirm) {
            onConfirm();
          }
        },
        focus: confirmFocus || false,
      },
    ];
    this.showAlert = true;
  }
  setConfirmationAlertv2(alert: AlertV2Component, data: ConfirmationAlert) {
    alert.setConfirmAlertData(data);
  }
  finishConfirmationAlertv2(alert: AlertV2Component, onClose?: any) {
    alert.closeAlert(onClose, true);
  }
  setSuccessAlert(title: string, body: string, action?: any) {
    this.size = "modal-md";
    this.title_icon = 'check_circle';
    this.title = title;
    this.title_color = "text-success";
    this.body = body;
    this.showFooter = true;
    this.buttons = [
      {
        title: "Cerrar",
        btn_class: "btn-default",
        onClick: () => {
          this.closeAlert();
          if (action) {
            action();
          }
        },
      },
    ];
    this.showAlert = true;
    if (action) {
      this.onCloseAction = action;
    }
  }
  setErrorAlert(title: string, body: string, action?: any) {
    this.size = "modal-md";
    this.title_icon = 'cancel';
    this.title = title;
    this.title_color = "text-danger";
    this.body = body;
    this.showFooter = true;
    this.buttons = [
      {
        title: "Cerrar",
        btn_class: "btn-default",
        onClick: () => {
          this.closeAlert();
          if (action) {
            action();
          }
        },
      },
    ];
    this.showAlert = true;
    if (action) {
      this.onCloseAction = action;
    }
  }
  resetAlert() {
    this.size = "modal-md";
    this.showFooter = false;
    this.title = "";
    this.loading.set(false);
    this.body = "";
    this.title_icon = null;
    this.title_color = "";
    this.buttons = [];
    this.onCloseAction = null;
  }
  closeAlert(forceClose: boolean = false) {
    if (!this.syncing() || forceClose) {
      this.syncing.set(false);
      if (this.onCloseAction) {
        this.onCloseAction();
      }
      this.showAlert = false;
      this.resetAlert();
    }
  }
}
